import React from "react";
import ServicePrices from "@components/blocks/ServicePrices/ServicePrices";
import ShopikoData from "@components/blocks/ServicePrices/data/ShopikoData";
import CharacteristicsA from "@components/blocks/CharacteristicsA/CharacteristicsA";
import {ContextTaxonomyProvider} from "@contexts/ContextTaxonomyProvider";
import {ContextServicesFeaturesTableProvider} from "@contexts/ContextServicesFeaturesTable";

const TabPrices = () => {
	return (
	  <>
		  <ContextTaxonomyProvider>
			  <ServicePrices data={ShopikoData} color={'color-brand-green-400'}/>
		  </ContextTaxonomyProvider>

		  <ContextServicesFeaturesTableProvider>
			  <CharacteristicsA data={ShopikoData} color={'color-brand-green-400'}/>
		  </ContextServicesFeaturesTableProvider>
	  </>
	)
}

export default TabPrices;